export const DESKTOP = 1334;
export const TABLET = 768;
export const MOBILE = 500;


